import { InjectionToken } from "@angular/core";

export const GOOGLE_MAPS_KEY = new InjectionToken('', {
    factory: () => 'AIzaSyD9tINzhxqS2pPZCCsNf_M41z6Kwd09w_c'
});
